<template>
  <div class="hero-pet-comment-page">
    <top-bar title="Heropet">
      <img src="@/assets/icon/medal-white.png" alt="medal icon">
    </top-bar>
    <container class="hero-pet-comment-container">
      <hero-pet-card
        :hero="hero"
        :showCta="false"/>
      <div class="col-sm-12 col-md-8 col-lg-7 offset-lg-1">
        <div class="comment-form-container">
          <h2>ร่วมชื่นชมและขอบคุณ</h2>
          <hr/>
          <div class="form-header">แด่ น้อง {{ hero.name }},</div>
          <form method="post" @submit.prevent="postComment">
            <div class="form-group">
              <textarea name="comment" v-model="comment" class="form-control" id="comment-form" rows="3" placeholder="พิมพ์ข้อความของคุณที่นี่..."/>
            </div>
            <div class="form-group row">
              <label for="from" class="col-sm-2 col-form-label">จาก</label>
              <div class="col-sm-10">
                <input name="commenter" v-model="commenter" type="text" class="form-control" id="input-from" placeholder="พิมพ์ชื่อของคุณที่นี่...">
              </div>
            </div>
            <div class="clearfix">
              <input class="btn btn-primary float-right submit-btn" type="submit" name="" value="Done">
            </div>
          </form>
        </div>
        <div class="comment-container">
          <div class="comment" v-for="comment in comments" :key="comment.created">
            <div class="title">
              <img src="@/assets/icon/comment-red.png" alt="comment">
              {{ comment.from }}
              <span class="date">{{ comment.date }}</span>
            </div>
            <hr/>
            <p>
              {{ comment.comment }}
            </p>
          </div>
        </div>
      </div>
    </container>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue'
import Container from '@/components/Container.vue'
import HeroPetCard from '@/components/HeroPetCard.vue'

export default {
  name: 'HeroPetComment',
  data () {
    return {
      hero: {},
      comments: [],
      commenter: '',
      comment: ''
    }
  },
  mounted () {
    this.getPetDetail()
    this.updateComments()
  },
  methods: {
    postComment () {
      this.$http.post('pet/comment/', {
        pet: this.$route.params.petId,
        comment: this.comment,
        commenter: this.commenter
      }).then((response) => {
        if (response.data.status === 'success') {
          this.updateComments()
          this.comment = ''
          this.commenter = ''
        }
      })
    },
    getPetDetail () {
      this.$http.get('pet/detail/', { params: { pet_id: this.$route.params.petId } }).then((response) => {
        var heroPet = response.data.result[0]
        this.hero = {
          id: heroPet.id,
          name: heroPet.name,
          image: heroPet.image,
          donations: heroPet.blood_donations.length,
          comments: heroPet.pet_comments.length
        }
      })
    },
    updateComments () {
      this.$http.get('pet/comment/', { params: { pet_id: this.$route.params.petId } }).then((response) => {
        var commentsResult = response.data.result
        this.comments = []
        for (var comment of commentsResult) {
          this.comments.push({
            from: comment.commenter,
            date: comment.last_updated,
            comment: comment.comment
          })
        }
      })
    }
  },
  components: {
    HeroPetCard,
    TopBar,
    Container
  }
}
</script>

<style scoped lang="scss">
.hero-pet-comment-page {
  background-color: $gray-100;
}

.hero-pet-comment-container {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.comment-form-container {
  background-color: white;
  padding: 1rem 1rem;
  box-shadow: $box-shadow-sm;
  hr {
    margin: 0.5rem 0;
  }
  h2 {
    font-size: $h5-font-size;
    color: $primary;
  }
  .form-header {
    margin-bottom: 0.5rem;
  }
  .submit-btn {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.comment-container {
  margin-top: 2rem;
}
.comment {
  margin-bottom: 2rem;
  img {
    width: 1.5rem;
    margin-right: 0.25rem;
  }
  .date {
    float: right;
  }
  hr {
    margin: 0.5rem 0;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .hero-pet-comment-container {
    padding-top: 3rem;
    padding-bottom: 5rem;
  }

  .comment-form-container {
    padding: 1.5rem 2rem;
    hr {
      margin: 1rem 0;
    }
    .form-header {
      margin-bottom: 1rem;
    }
  }

  .comment {
    img {
      width: 2rem;
      margin-right: 0.5rem;
    }
  }
}
</style>
